import Layout from 'components/Layout';
import {
  IHeaderContainer,
  HeaderContainer as ResourcesHeaderSection,
} from 'containers/Resources/HeaderContainer';
import { IResourceListContainer } from 'containers/Resources/ResourceListContainer';
import { graphql } from 'gatsby';
import React, { LazyExoticComponent, lazy } from 'react';
import { IResource } from 'utils/types';

import { SEO } from '../components/SEO';
const ResourceListSection = lazy(
  () => import('containers/Resources/ResourceListContainer'),
);

const components: {
  ResourcesHeaderSection: React.FC<IHeaderContainer>;
  ResourceListSection: LazyExoticComponent<React.FC<IResourceListContainer>>;
} = {
  ResourcesHeaderSection,
  ResourceListSection,
};

type Props = {
  data: {
    resourcesContent: {
      title: string;
      sections: {
        componentName: string;
        headline: string;
        slug: string;
      }[];
      resources?: IResource[];
    };
  };
};

export const Head = () => <SEO />;

export const resourcesTemplate = ({ data }: Props) => {
  const { resourcesContent } = data;
  const { sections } = resourcesContent;

  return (
    <Layout>
      {sections.map((section, i: number) => {
        // @ts-ignore
        if (components[section.componentName]) {
          return React.createElement(
            // @ts-ignore
            components[section.componentName],
            {
              content: section,
              key: `${section.componentName}-${i}`, // handles the case for duplicate section keys
            },
          );
        }
        return null; // Return null for components that don't exist
      })}
    </Layout>
  );
};

export default resourcesTemplate;

export const data = graphql`
  query {
    resourcesContent: contentfulPage(pageId: { eq: "EHSResources" }) {
      title
      sections {
        headline
        componentName
        slug
        backgroundColor
        description {
          description
        }
        richTextBody {
          raw
        }
        resources {
          slug
          updatedAt(formatString: "YYYY-MM-DDTHH:mm:ss.sssZ")
          type
          title
          summary {
            summary
            childMarkdownRemark {
              html
            }
          }
          cta {
            text
            url
            isIframe
          }
          image {
            title
            gatsbyImageData(placeholder: BLURRED, quality: 75)
          }
        }
      }
    }
  }
`;
